import React, { Suspense, useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { DataProvider } from "./Components/DataContext";
import AddTeacher from "./Pages/UserManagement/AddTeacher";
import DetailFeedback from "./Pages/UserManagement/DetailFeedback";
import AddSchool from "./Pages/UserManagement/AddSchool";
import ViewProgram from "./Pages/Program Management/ViewProgram";
import CoachList from "./Pages/Coach_Management/CoachList";
import AddCoach from "./Pages/Coach_Management/AddCoach";
import CoachView from "./Pages/Coach_Management/CoachView";
import CoachFeedback from "./Pages/Coach_Management/CoachFeedback";
import SubAdminCreate from "./Pages/SubAdmin Management/SubAdminCreate.jsx";
import Loader from "./Components/Loader/Loader.jsx";
import { StatusToastProvider } from "./Components/Context/StatusToastContext.js";
import StatusToaster from "./Components/Context/StatusToaster.js";
import TotalSessionMonth from "./Pages/Coach_Management/TotalSessionMonth.jsx";
import TotalSessionProgress from "./Pages/Coach_Management/TotalSessionProgress.jsx";
import TotalVisitedSchool from "./Pages/Coach_Management/TotalVisitedSchool.jsx";
import TeacherArea from "./Pages/Coach_Management/TeacherArea.jsx";
import AssignedTeacherFeedback from "./Pages/AssignedCoach/TeacherFeedback.jsx";
import Reports from "./Pages/Reports/Reports.jsx";
import CoachTragetManagementView from "./Pages/Coach_Target_Managemen/CoachTragetManagementView.jsx";


const CMSManagement = React.lazy(() => import("./Pages/CMS Management/CMSManagement"));
const Layout = React.lazy(() => import("./Components/Layout/Layout"));
const SubAdminManagement = React.lazy(() => import("./Pages/SubAdmin Management/SubAdminManagement"));
const CreateNewProfile = React.lazy(() => import("./Pages/SubAdmin Management/CreateNewProfile"));
const SubAdminView = React.lazy(() => import("./Pages/SubAdmin Management/Sub-Admin-View"));
const Spinnerr = React.lazy(() => import("./Components/Spinner/Spinner"));
const Login = React.lazy(() => import("./Pages/Login/Login"));
const CoachLogin = React.lazy(() => import("./Pages/Login/CoachLoagin.jsx"));
const CoachOtp = React.lazy(() => import("./Pages/Login/CoachVerifyOtp.jsx"));
const UpdatePassword = React.lazy(() => import("./Pages/Login/UpdatePassword"));
const Dashboard = React.lazy(() => import("./Pages/Dashboard/Dashboard"));
const UserManagement = React.lazy(() => import("./Pages/UserManagement/UserManagement"));
const TeacherManagement = React.lazy(() => import("./Pages/Teacher Management/TeacherList"));
const AddTeacherTM = React.lazy(() => import("./Pages/Teacher Management/AddTeacherTM"));
const ViewTeacher = React.lazy(() => import("./Pages/Teacher Management/TeacherView"));
const TeacherFeedback = React.lazy(() => import("./Pages/Teacher Management/TeacherFeedback"));
const ChangePassword = React.lazy(() => import("./Pages/UserManagement/ChangePassword"));


const ProgramManagement = React.lazy(() => import("./Pages/Program Management/ProgramList"));
const AddProgram = React.lazy(() => import("./Pages/Program Management/AddProgram"));
const viewProgram = React.lazy(() => import("./Pages/Program Management/ViewProgram"));
const ViewUser = React.lazy(() => import("./Pages/UserManagement/ViewUser"));
const UserEvent = React.lazy(() => import("./Pages/UserManagement/UserEvent"));
const ForgotPassword = React.lazy(() => import("./Pages/Login/ForgotPassword"));
const AuthLayout = React.lazy(() => import("./Components/Layout/AuthLayout"));
const EventManagement = React.lazy(() => import("./Pages/Event Management/EventManagement"));
const ViewEvent = React.lazy(() => import("./Pages/Event Management/EventView"))
const VendorNewView = React.lazy(() => import("./Pages/Event Management/VendorNewView"))

const ResourceManagement = React.lazy(() => import("./Pages/Resource Management/resource_management"))
const AddResource = React.lazy(() => import("./Pages/Resource Management/AddResourse"))

const SupportRequest = React.lazy(() => import("./Pages/Support Management/SupportRequest"))
const LocationMaster = React.lazy(() => import("./Pages/Location Management/LocationManagement.jsx"))
const LocationView = React.lazy(() => import("./Pages/Location Management/LocationView.jsx"))

const AssignedCoach = React.lazy(() => import("./Pages/AssignedCoach/AssignedCoach.jsx"))
const AssignedCoachSchool = React.lazy(() => import("./Pages/AssignedCoach/AssignedSchoolView.jsx"))
const AssignedTeacherView = React.lazy(() => import("./Pages/AssignedCoach/AssTeacherView.jsx"))

const CoachTargetList =React.lazy(() => import("./Pages/Coach_Target_Managemen/CoachTragetManagement.jsx"))
const AddTarget =React.lazy(() => import("./Pages/Coach_Target_Managemen/AddTarget.jsx"))
const UpdateProfile =React.lazy(() => import("./Pages/UpdateProfile/UpdateProfile.jsx"))

const CalenderManagement=React.lazy(() => import("./Pages/Calendar Management/CalenderManagement.jsx"))

function App() {
  const isSessionExpired = () => {
    const lastActivityTime = localStorage.getItem("lastActivityTime");
    if (lastActivityTime) {
      return Date.now() - parseInt(lastActivityTime, 10) > 60 * 60 * 1000; // 1 hour in milliseconds
    }
    return true;
  };
  useEffect(() => {
    if (isSessionExpired()) {
      localStorage.clear();
    }
  }, []);
  const PrivateOutlet = () => {
    const loginSuccess = useSelector((state) => state.loginInfo.userInformation);
    const storedStatus = localStorage.getItem("status");
    let isLoggedIn = false;
    try {
      isLoggedIn =
        (loginSuccess?.code === 200) ||
        (storedStatus && JSON.parse(storedStatus) === 200);
    } catch (error) {
      console.error("Error parsing localStorage data:", error);
    }
    return <Outlet />
  };
  const [showLoader, setShowLoader] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => setShowLoader(true), 10); // delay before showing
    return () => clearTimeout(timer); // clear timer on unmount
  }, []);
  return (
   
    <DataProvider>
      
      <Router>
      <StatusToastProvider>
      <StatusToaster />
        <Suspense fallback={<Loader isLoading={showLoader} />}>
       
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<AuthLayout />}>
              <Route index element={<Login />} />
              <Route path="Coach-login" element={<CoachLogin />} />
              <Route path="Coach-Verify" element={<CoachOtp />} />
              <Route path="reset-password/:token" element={<UpdatePassword />} />
              <Route path="forgot-password" element={<ForgotPassword />} />
            </Route>
            {/* Private Routes */}
            <Route element={<PrivateOutlet />}>
              <Route element={<Layout />}>
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="change-password" element={< ChangePassword />} />
                <Route path="school-management">
                  <Route index element={<UserManagement />} />
                  <Route path="add-School" element={< AddTeacher />} />
                  <Route path="view-user">
                    <Route index element={<ViewUser />} />
                    <Route path="add-teacher" element={<AddSchool />} />
                    <Route path="View-teacher" element={<ViewTeacher />} />
                    <Route path="userevent" element={<UserEvent />} />
                    <Route path="detailFeedback" element={<DetailFeedback />} />
                  </Route>
                </Route>
                <Route path="/Update-Profile" element={<UpdateProfile />} />
                <Route path="teacher-management">
                  <Route index element={<TeacherManagement />} />
                  <Route path="add_teacherTM" element={<AddTeacherTM />} />
                  <Route path="teacher-view">
                    <Route index element={<ViewTeacher />} />
                    <Route path="teacher-Feedback" element={<TeacherFeedback />} />
                  </Route>
                </Route>
                <Route path="coach-management">
                  <Route index element={<CoachList />} />
                  <Route path="view-coach">
                    <Route index element={<CoachView />} />
                    <Route path="coach-TotalSession" element={<TotalSessionMonth />} />
                    <Route path="coach-TotalProgress" element={<TotalSessionProgress />} />
                    <Route path="coach-VisitedSchool" element={<TotalVisitedSchool />} />
                    <Route path="coach-Feedback" element={<CoachFeedback />} />
                    <Route path="TeacherArea" element={<TeacherArea />} />
                  </Route>
                  <Route path="add-coach" element={<AddCoach />} />
                </Route>
                <Route path="program-management">
                  <Route index element={<ProgramManagement />} />
                  <Route path="view-program" element={<ViewProgram />} />
                  <Route path="add-program" element={<AddProgram />} />
                </Route>
                <Route path="coach-target-management">
                  <Route index element={<CoachTargetList />} />
                  {/* <Route path="view-coach">
                    <Route index element={<CoachView />} />
                    <Route path="coach-Feedback" element={<CoachFeedback />} />
                  </Route> */}
                  <Route path="add-target" element={<AddTarget />} />
                  <Route path="view-coach-target" element={<CoachTragetManagementView />} />
                </Route>
                <Route path="resource-management">
                  <Route index element={<ResourceManagement />} />
                  <Route path="add-resource" element={<AddResource />} />
                </Route>
                <Route path="assigned-schools">
                  <Route index element={<AssignedCoach />} />
                  <Route path="AssignedSchoolview" element={<AssignedCoachSchool />} />
                  <Route path="AssignedSchoolview/AssignedTeacherview" element={<AssignedTeacherView />} />
                  <Route path="AssignedTeacherview/TeacherFeedBack" element={<AssignedTeacherFeedback />} />
                </Route>
                <Route path="support-request" element={<SupportRequest />} />
                <Route path="reports" element={<Reports />} />
                <Route path="Location-management" >
                  <Route index element={<LocationMaster />} />
                  <Route path="location-view" element={<LocationView />} />
                </Route>
                <Route path="Calendar-management" >
                  <Route index element={<CalenderManagement />} />
                  <Route path="location-view" element={<LocationView />} />
                </Route>
                <Route path="/terms-&-Conditions" element={<CMSManagement />} />
                <Route path="subadmin-management" element={<SubAdminManagement />} />
                <Route path="subadmin-management/addSubadmin" element={<SubAdminCreate />} />
                <Route path="/subadmin-management" element={<SubAdminManagement />} />
                <Route path="/subadmin-management/add-role" element={<CreateNewProfile />} />
                <Route path="/subadmin-management/SubadminView" element={<SubAdminView />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Route>
            </Route>
          </Routes>
        </Suspense>
        </StatusToastProvider>
      </Router>
      
    </DataProvider>
   
   
  );
}

export default App;
